const PHRASES = [
  { q: "best water damage restoration near me", r: "ChatGPT #6" },
  { q: "furnace repair in kansas city", r: "Gemini #8" },
  { q: "who fixes burst pipes in olathe", r: "ChatGPT #4" },
  { q: "top rated hvac companies near me", r: "Gemini #10" },
];

function GoogleVsLlm({ dark }) {
  const grey = dark ? "#94A3B8" : "#334155";
  const textGrey = dark ? "#CBD5E1" : "#334155";
  const chip = dark ? "#0F172A" : "#FFFFFF";
  return (
    <svg
      viewBox="0 0 480 280"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="w-full"
      aria-hidden="true"
    >
      {/* two engine circles */}
      <circle cx="170" cy="150" r="95" stroke={grey} strokeWidth="3" />
      <circle cx="170" cy="150" r="80" stroke={grey} strokeWidth="1.5" opacity="0.45" />
      <circle cx="310" cy="150" r="95" stroke="#FF5500" strokeWidth="3" />
      <circle cx="310" cy="150" r="80" stroke="#FF5500" strokeWidth="1.5" opacity="0.45" />
      {/* google magnifier */}
      <circle cx="146" cy="88" r="13" stroke="#FF5500" strokeWidth="3" />
      <path d="M156 98 l12 12" stroke="#FF5500" strokeWidth="3" />
      <text x="170" y="158" textAnchor="middle" fontFamily="monospace" fontWeight="bold" fontSize="26" fill={textGrey} stroke="none">
        GOOGLE
      </text>
      <text x="170" y="188" textAnchor="middle" fontFamily="monospace" fontWeight="bold" fontSize="26" fill={textGrey} stroke="none">
        SEARCH
      </text>
      {/* llm chat bubble + spark */}
      <rect x="286" y="72" width="50" height="36" rx="9" stroke={grey} strokeWidth="2.5" />
      <path d="M296 118 l6 10 8 -10" stroke={grey} strokeWidth="2.5" />
      <circle cx="303" cy="90" r="3.5" fill="#FF5500" stroke="none" />
      <circle cx="312" cy="90" r="3.5" fill={grey} stroke="none" />
      <circle cx="321" cy="90" r="3.5" fill="#FF5500" stroke="none" />
      <text x="310" y="158" textAnchor="middle" fontFamily="monospace" fontWeight="bold" fontSize="26" fill="#FF5500" stroke="none">
        LLM
      </text>
      <text x="310" y="188" textAnchor="middle" fontFamily="monospace" fontWeight="bold" fontSize="26" fill="#FF5500" stroke="none">
        SEARCH
      </text>
      {/* vs badge in the overlap */}
      <circle cx="240" cy="150" r="27" fill={chip} stroke="#FF5500" strokeWidth="3" />
      <text x="240" y="159" textAnchor="middle" fontFamily="monospace" fontWeight="bold" fontSize="22" fill="#FF5500" stroke="none">
        VS
      </text>
      {/* orbit sparks */}
      <circle cx="66" cy="42" r="5" stroke={grey} strokeWidth="2" />
      <circle cx="416" cy="52" r="6" fill="#FF5500" stroke="none" opacity="0.7" />
      <circle cx="432" cy="232" r="5" stroke={grey} strokeWidth="2" />
      <path d="M52 244 l10 -8 M34 68 l8 6" stroke="#FF5500" strokeWidth="2.5" opacity="0.7" />
    </svg>
  );
}

export default function SampleMonthlyReport({
  theme = "light",
  testid = "sample-monthly-report",
}) {
  const dark = theme === "dark";
  return (
    <div
      data-testid={testid}
      className={
        dark
          ? "rounded-2xl bg-slate-900 p-6 text-slate-100"
          : "rounded-3xl border border-white/10 bg-white p-8 text-slate-900 shadow-2xl"
      }
    >
      <div className="flex items-center justify-between gap-3">
        <h3
          className={`font-display ${dark ? "text-xl" : "text-2xl"} font-bold`}
        >
          Sample monthly report
        </h3>
        <span
          className={`rounded-full border px-3 py-1 font-mono text-[11px] uppercase tracking-[0.15em] ${dark ? "border-gold/60 bg-gold/15 text-gold" : "border-gold/60 bg-gold/15 text-[#8A5B00]"}`}
        >
          Sample — illustrative
        </span>
      </div>
      <div className={`grid grid-cols-2 gap-6 ${dark ? "mt-5" : "mt-7"}`}>
        <div>
          <div
            className={`font-mono text-[13px] uppercase tracking-[0.18em] ${dark ? "text-slate-400" : "text-faint"}`}
          >
            Before — Sept 2026
          </div>
          <div
            className={`mt-4 space-y-2 ${dark ? "text-base text-slate-300" : "text-lg text-mist"}`}
          >
            <p>Not ranked in top 20</p>
            <p>ChatGPT mentions: 0/10</p>
            <p>Gemini mentions: 2/10</p>
          </div>
          <div className="mt-4">
            <GoogleVsLlm dark={dark} />
          </div>
        </div>
        <div className={`rounded-2xl ${dark ? "bg-white/10 p-4" : "bg-ink p-5"}`}>
          <div
            className={`font-mono text-[13px] uppercase tracking-[0.18em] ${dark ? "text-slate-400" : "text-faint"}`}
          >
            After — Oct 2026
          </div>
          <div
            className={`font-display font-extrabold text-flame ${dark ? "mt-1 text-4xl" : "mt-2 text-5xl"}`}
          >
            #6
          </div>
          <div
            className={`mt-3 space-y-1 ${dark ? "text-base text-slate-200" : "text-lg text-mist"}`}
          >
            <p>Top 10 in your city</p>
            <p>ChatGPT mentions: 7/10</p>
            <p>Gemini mentions: 9/10</p>
          </div>
        </div>
      </div>
      <div
        className={`border-t pt-4 ${dark ? "mt-5 border-white/10" : "mt-6 border-slate-200"}`}
      >
        <div
          className={`font-mono text-[13px] uppercase tracking-[0.18em] ${dark ? "text-slate-400" : "text-faint"}`}
        >
          Example queries we track
        </div>
        <ul className={`mt-3 space-y-2 ${dark ? "text-base" : "text-lg"}`}>
          {PHRASES.map((p) => (
            <li
              key={p.q}
              className="flex flex-wrap items-center justify-between gap-2"
            >
              <span className={dark ? "text-slate-200" : "text-slate-800"}>
                &ldquo;{p.q}&rdquo;
              </span>
              <span className="font-mono text-[13px] font-semibold uppercase tracking-[0.1em] text-flame">
                {p.r}
              </span>
            </li>
          ))}
        </ul>
      </div>
      <p
        className={`mt-5 border-t pt-4 text-base ${dark ? "border-white/10 text-slate-400" : "border-slate-200 text-faint"}`}
      >
        Example only — your dashboard shows your business's real numbers,
        updated monthly.
      </p>
    </div>
  );
}
